const CategoriesList = ({ productCategories, setActiveCategory }: any) => {
  return (
    <div className="flex flex-wrap items-stretch justify-start">
      {productCategories.map((i: any, index: any) => (
        <div key={index} className="w-1/3 max-xl:w-1/2 max-md:w-full p-2">
          <button
            className="bg-white text-center font-bold rounded-md"
            onClick={() => setActiveCategory(i.category)}
          >
            <div className="py-3">{i.category}</div>
            <div className="p-2">
              <img src={i.img} alt="" />
            </div>
          </button>
        </div>
      ))}
    </div>
  );
};

export default CategoriesList;
